
'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { Home, PlusCircle, Heart, User, Search, ShoppingBag } from 'lucide-react';
import { cn } from '@/lib/utils';

export default function BottomNav() {
  const pathname = usePathname();

  const navItems = [
    { icon: Home, label: 'الرئيسية', href: '/' },
    { icon: Search, label: 'السيارات', href: '/buy' },
    { icon: PlusCircle, label: 'أضف', href: '/marketplace/new', primary: true },
    { icon: ShoppingBag, label: 'السوق', href: '/marketplace' },
    { icon: User, label: 'ملفي', href: '/profile' },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-slate-100 flex items-center justify-around h-20 px-4 md:hidden pb-safe">
      {navItems.map((item) => (
        <Link key={item.href} href={item.href} className="flex flex-col items-center justify-center gap-1 group">
          <div className={cn(
            "p-2 rounded-2xl transition-all",
            item.primary ? "bg-primary text-white -mt-10 shadow-lg shadow-primary/30 border-4 border-[#F8FAFC]" :
              pathname === item.href ? "text-primary bg-blue-50" : "text-slate-400 group-hover:text-primary"
          )}>
            <item.icon className={cn(item.primary ? "h-7 w-7" : "h-5 w-5")} />
          </div>
          {!item.primary && (
            <span className={cn(
              "text-[9px] font-bold",
              pathname === item.href ? "text-primary" : "text-slate-400"
            )}>
              {item.label}
            </span>
          )}
        </Link>
      ))}
    </nav>
  );
}
